// extracted by mini-css-extract-plugin
export default {"button":"primary-small__button___As-xw primary__button___frFdc base__button___zT0JW"};